import fetchDelete from "./fetchDelete";

const deleteReviewReply = async (businessUid, reviewUid) => {
  return fetchDelete(
    `/business/${businessUid}/reviews/${reviewUid}/deleteReply`
  );
};

export default deleteReviewReply;
